/* eslint-disable no-unused-vars */
import { ConfigApi } from "../api/base/ConfigApi";
import ApiStore from "./AppStore/ApiStore";
import ApplicationStore from "./AppStore/ApplicationStore";
import ModalViewerStore from "./AppStore/ModalViewerStore";
import StepByStepTabStore from "./AppStore/StepByStepTabStore";

class RootStore {
  applicationStore: ApplicationStore;
  stepByStepTabStore: StepByStepTabStore;
  modalViewerStore: ModalViewerStore;

  constructor(configApi: ConfigApi) {
    const api = new ApiStore(configApi);
    this.applicationStore = new ApplicationStore(api);
    this.stepByStepTabStore = new StepByStepTabStore(this.applicationStore);
    this.modalViewerStore = new ModalViewerStore();
  }
}

export default RootStore;
